<template>
  <div :id="'list_items'" class="context--expandlist__container" >
    <div
    @click="handleExpand"
    ref="list_items_title"
    :id="'list_items_title'"
    class="context--title expandable"
    >
      <span class="context--title__text">
        {{ title }}
        <i class="fas fa-info-circle"></i>
      </span>
      <span class="context--title__badge">{{ list.length }}</span>
      <div  class="context--title__expandable">
        <i :class="[expandFlag ? 'fas fa-angle-up' : 'fas fa-angle-down']"></i>
      </div>
    </div>
    <!-- <ContextTitle @open-editable="handleExpand" :id="'list_items_title'" class="" :title="title" :badgeNumber="list.length" :isExpandable="true" :expandFlag="expandFlag"/> -->
    <div v-if="expandFlag" class="context--expandlist__list">
      <ul>
        <li class="context--expandlist__card" :class="{'selected--card': unit.id === selectedUnitID, 'toggled--card':  unit.toggled }" @click="handleListItem(unit.id)" :id="unit.id" :key="index" v-for="(unit, index) in list">
          <template v-if="!isCustomSlot">
            <span class="context--expandlist__title">
              {{unit.name}}
            </span>
            <template v-if="unit.value !== undefined">
              <span class="context--expandlist__subtitle">
                {{unit.value.weight}} kg
              </span>
              <span v-if="unit.value.dimensions !== undefined" class="context--expandlist__subtitle context--text--alignLeft">
                {{ unit.value.dimensions | dimensionValue }} cm
              </span>
            </template>
            <span v-if="unit.subtitle !== undefined"
            class="context--expandlist__subtitle context--text--alignLeft"
            style="flex: 1 1 10%; width: 10%"
            >
                {{unit.subtitle}}
            </span>
            <span v-if="unit.buyerRef != null"
            class="context--expandlist__subtitle context--text--alignLeft"
            style="1 1 20%; width: 20%"
            >
                {{unit.buyerRef}}
            </span>
          </template>
          <template v-else>
            <slot name="customListElement" :elementIndex="index"></slot>
          </template>
          <div v-if="isHoverableActions" class="context--expandlist__hover--actions">
            <div>
              <i v-if="!unit.toggled" class="far fa-circle" @click="handleToggleAction(unit.id)"></i>
              <i v-else class="far fa-check-circle" @click="handleToggleAction(unit.id)"></i>
              <!-- <i class="fas fa-hand-pointer" :style="[showFlag ? {color: '#00A991'} : {}]" @click="handleShowAction(unit.id)"></i> -->
            </div>
          </div>
          <!-- <span v-else>
            <i class="fas fa-check-circle"></i>
          </span> -->
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContextExpandList',
  props: {
    title: { type: String, default: 'drops.shipping_units' },
    list: { type: Array, default: () => [] },
    isClickable: { type: Boolean, default: false },
    handleClickListItem: { type: Function, default: () => 1 },
    isHoverableActions: { type: Boolean, default: false },
    toggleAction: { type: Function, default: () => 1 },
    showAction: { type: Function, default: () => 1 },
    isCustomSlot: { type: Boolean, default: false },
    closeOnSelect: { type: Boolean, default: true },
    isSynced: { type: Boolean, default: false },
    syncedObject: { type: Object, default: () => {} }
  },
  data () {
    return {
      expandFlag: false,
      selectedUnitID: null,
      toggleFlag: [],
      showFlag: false
    }
  },
  methods: {
    handleExpand (evt) {
      if (this.$refs['list_items_title'].contains(evt.target)) {
        this.expandFlag = !this.expandFlag
      }
    },
    handleListItem (unitID) {
      if (this.closeOnSelect) {
        this.expandFlag = !this.expandFlag
      }
      if (this.isClickable) {
        this.selectedUnitID = this.selectedUnitID === unitID ? null : unitID
        this.handleClickListItem(unitID)
      }
    },
    handleToggleAction (unitID) {
      this.toggleAction(unitID)
      // if (this.toggleFlag.indexOf(unitID) >= 0) {
      //   this.toggleFlag.splice(this.toggleFlag.indexOf(unitID), 1)
      //   this.toggleAction(unitID, 'remove')
      // } else {
      //   this.toggleFlag.push(unitID)
      //   this.toggleAction(unitID, 'add')
      // }
    },
    handleShowAction (unitID) {
      this.showFlag = !this.showFlag
      // this.toggleFlag = !this.toggleFlag
      // this.toggleAction(unitID)
    }
  },
  watch: {
    syncedObject: {
      deep: true,
      immediate: true,
      handler (val, oldVal) {
        if (this.isSynced) {
          if (this.syncedObject === null) {
            this.selectedUnitID = null
          } else if (Object.keys(this.syncedObject).indexOf('id') >= 0) {
            this.selectedUnitID = this.syncedObject['id']
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.context--title {
  border-radius: 5px;
  &:hover {
    background-color: #f2f2f2;
  }
}

</style>
